<template>
    <div class="mb-5">
        <strong class="d-block">{{ offer.info.service }} ({{ offer.info.tariff }})</strong>
        <strong class="d-block">{{ $t('date') }}: {{ $filters.dateFormat(offer.startDate) }}</strong>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_EXTRA_SERVICE_CONDITIONS_INFO} from '@/utils/event-bus'

    @Component
    export class ExtraServiceConditionsModalInfo extends Vue {
        offer = {info: {}}

        mounted() {
            EventBus.$on(SHOW_EXTRA_SERVICE_CONDITIONS_INFO, this.showInfo)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_EXTRA_SERVICE_CONDITIONS_INFO, this.showInfo)
        }

        showInfo(offer) {
            this.offer = offer
        }
    }

    export default ExtraServiceConditionsModalInfo
</script>
